<template>
  <div>
    <ContactDetailsForm
      :customer="customer"
      :basic-details-card-title="$t(`sidebar.owner`) + ' Details'"
      :show-contact-phones="showContactPhones"
      :show-contact-emails="showContactEmails"
      :show-contact-addresses="showContactAddresses"
      @customer-updated="updateCustomer"
    />
  </div>
</template>

<script>
import ContactDetailsForm from "./ContactDetailsForm.vue";
import {showWarning} from "../../utils/notification.utils";
import permissionService from "../../service/permission.service";

export default {
  components: {
    ContactDetailsForm,
  },
  props: {
    customer: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      permissions: {},
      pagePermissions: ["CUSTOMER_READ", "CUSTOMER_DELETE", 'BUSINESS_UPDATE'],
      showContactPhones: true,
      showContactEmails: true,
      showContactAddresses: true,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentStore() {
      return localStorage.getItem("mid");
    }
  },
  methods: {
    updateCustomer(updatedCustomer) {
      this.customer = {...updatedCustomer};
    },
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push("/login");
      return;
    }

    const result = await permissionService.checkPermissions(this.pagePermissions);
    if (!result.success) {
      await showWarning('Error during permissions check')
      return;
    }

    this.permissions = result.data;

    console.log(this.permissions);

    if (!this.permissions['BUSINESS_UPDATE']) {
      this.showContactPhones = false;
      this.showContactEmails = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContactDetails/ContactDetailsPageBody.vue